import React, { useEffect } from 'react';
import { useRovoButtonNodeActions } from '../state/useRovoButtonNode.tsx';
import { AiRovoButtonWrapperRefresh } from './AiRovoButtonWrapperRefresh.tsx';

export const AiRovoButtonNodeProvider = (): null => {
	const { setNode } = useRovoButtonNodeActions();

	useEffect(() => {
		const node = <AiRovoButtonWrapperRefresh />;
		setNode(node);
		return () => {
			setNode(null);
		};
	}, [setNode]);

	return null;
};
